function env() {
  if (window.location.href.indexOf("localhost") != -1) {
    return "DEV"
  } else if (window.location.href.indexOf("stage") != -1) {
    return "STAGE"
  } else if (window.location.href.indexOf("test.") != -1) {
    return "TEST"
  } else if (window.location.href.indexOf("test2") != -1) {
    return "TEST2"
  } else {
    return "PRODUCT"
  }
}

export default env
